import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e07897"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))

import {Skeleton} from '@/logged/common/ui';
    import {storeToRefs} from 'pinia';
    import {useDisplayMode} from '../stores';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationTabsSkeletons',
  setup(__props) {

    const displayModeStore = useDisplayMode();

    const {displayMode} = storeToRefs(displayModeStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["skeleton-container flex", [_unref(displayMode)]])
  }, [
    _createElementVNode("div", null, [
      _createVNode(_unref(Skeleton)),
      _createVNode(_unref(Skeleton)),
      _createVNode(_unref(Skeleton)),
      _createVNode(_unref(Skeleton)),
      _createVNode(_unref(Skeleton)),
      _createVNode(_unref(Skeleton)),
      _hoisted_1,
      _createVNode(_unref(Skeleton))
    ])
  ], 2))
}
}

})